import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import ClientProvider from "../ClientProvider.js";
import { initI18N } from "../i18n/index.js";
export * as ThemeTypes from "../@types/index.js";
// Create a root container once
const container = document.getElementById("app");
const root = createRoot(container);
export const initiateClient = async (options) => {
    await initI18N(options);
    root.render(_jsx(ClientProvider, { ...options }));
    // // Setup HMR
    if (window.module?.hot) {
        window.module.hot.accept("./ClientProvider.js", async () => {
            // Re-import the updated App module
            const { default: NextApp } = await import("../ClientProvider.js");
            // Re-render the App
            root.render(_jsx(NextApp, { ...options }));
        });
    }
};
//# sourceMappingURL=bootstrap.js.map